import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'slick-carousel';

class Common {
    constructor() {

    }

    init() {
        this.bindEvents();

        //about us timeline
        if ($('.timeline-container').length) {
            this.initTimeline();
        }
    }

    bindEvents() {
        $('.form-container').validate();

        // phone mask
        //$('.js-phone-input').mask('(000) 000-0000');

        $('#contact-form').on('submit', e => { this.validateForm(e); });

        $('[data-hasdepending="true"]').on('change', e => { this.toggleDependingForm(e); });

        $(".notification-bar-close").click(function () {
            $(".notification-bar").fadeOut(); // Use fadeOut() for a smooth effect
        });

        $('.slick-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
        });

        $('.slick-slider--testimonials').slick({
            slideToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            autoplay: true,
        });

        $('.slick-slider--lendingOptions').slick({
            slideToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            autoplay: false,
            infinite: true,
            variableWidth: true,
        });
        
        $('.slick-slider--loans').slick({
            slidetoshow: 4,
            slidestoscroll: 1,
            arrows: true,
            fade: false,
            autoplay: false,
            infinite: true,
            variableWidth: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidestoshow: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidestoshow: 2
                    }
                }
            ]
        });

        $('.slick-slider--loansSingleSlide').slick({
            slidetoshow: 1,
            slidestoscroll: 1,
            arrows: true,
            fade: false,
            autoplay: false,
            infinite: true,
            variableWidth: false,
            dots: true,
        });

        $('.slick-slider--stateLoansFeatured').slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            fade: false,
            autoplay: true,
            infinite: true,
            variableWidth: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });
        
        $('.slick-slider--stateLoansAll').slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            fade: false,
            autoplay: true,
            infinite: true,
            variableWidth: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });

        $('#all-programs-tab').on('click', function (event) {
            setTimeout(function () {
                $('.slick-slider--stateLoansAll').slick('setPosition'); // Recalculate positions
            }, 100); // Small delay to ensure tab transition is complete
        });
        $('.slick-slider--reviews').slick({
            slideToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            autoplay: false,
            infinite: false,
            variableWidth: false,
            adaptiveHeight: true,
            dots: true,
        });
        //retail hero slider
        //$('.section-hero--home .slick-slider--hero').slick({
        //    slideToShow: 1,
        //    slidesToScroll: 1,
        //    arrows: true,
        //    //appendArrows: $('.section-hero .slick-dots'),
        //    fade: false,
        //    autoplay: false,
        //    infinite: true,
        //    variableWidth: true,
        //    adaptiveHeight: true,
        //    dots: true,
        //    //appendDots: $('.section-retail .slide-content'),
        //});

        //three column card widget
        $('.slick-slider--cardThreeColumn').slick({
            slideToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            autoplay: false,
            infinite: false,
            variableWidth: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        arrows: true,
                        dots: true,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        arrows: true,
                        dots: true
                    }
                }
            ]
        });


        if ($('#map-canvas').length) {
            // lhfs adds a marker to indicate the position
            function initialize() {
                console.log("initialize");
                var mapOptions = {
                    zoom: 15,
                    center: new google.maps.LatLng(37.972584, -122.055321)
                };
            var map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
            var image = '';
            var myLatLng = new google.maps.LatLng(37.972584, -122.055321);
            var trafficLayer = new google.maps.TrafficLayer(); trafficLayer.setMap(map);
            var contentString = '<div id="content">' +
                '</br></br><h6 id="firstHeading" class="firstHeading">Land Home Financial Services, Inc.</h6>' +
                '<div id="bodyContent">'
            '<p>1355 Willow Way, Suite 250<br>Concord, CA 94520<br>' +
                '<a href="https://lhfs.com/" target="_blank">[Web Site]</a> | ' +
                '<a href="https://www.google.com/maps/place/1355 Willow Way, Suite 250 Concord, CA 94520" target="_blank">[Larger Map]</a>' +
                '</p>'
                + '</div></div>';
            var infowindow = new google.maps.InfoWindow({
                content: contentString,
                maxWidth: 400
            });
            var lhfsMarker = new google.maps.Marker({
                animation: google.maps.Animation.DROP,
                position: myLatLng,
                map: map,
                icon: image,
                title: 'Land Home Financial Services, Inc.'
            });
            google.maps.event.addListener(lhfsMarker, 'click', function () {
                infowindow.open(map, lhfsMarker);
                map.setCenter(lhfsMarker.getPosition());
            });
            infowindow.open(map, lhfsMarker);
            };

            initialize();
            //window.addEventListener('load', initialize);
        }
    }

    initTimeline() {
        console.log("timeline");
        const items = document.querySelectorAll('.timeline-itemCircle');
        const contents = document.querySelectorAll('.timeline-itemContent');
        const container = document.querySelector('.timeline-container');

        items.forEach((item, index) => {
            item.addEventListener('click', () => {
                const year = item.getAttribute('data-year');
                const content = document.getElementById('year-' + year);

                // Hide all content boxes
                contents.forEach(c => c.classList.remove('active'));

                // Remove active class from all circles
                items.forEach(i => i.classList.remove('active'));

                // Add active class to clicked circle
                item.classList.add('active');

                // Show the corresponding content box
                content.classList.add('active');

                // Get container width and decide left or right
                const totalItems = items.length;
                const isSecondHalf = index >= Math.ceil(totalItems / 2);

                const itemRect = item.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();
                const itemCenter = itemRect.left + itemRect.width / 2 - containerRect.left;

                content.style.position = 'absolute';
                content.style.left = isSecondHalf ? 'auto' : '-30px';
                content.style.right = isSecondHalf ? '-30px' : 'auto';
            });
        });
    }

    conditionallyRequiredToggle(parentValue, item) {
        $(item).each((index, formGroup) => {
            let $formInput = $(formGroup).find('.conditionally-required');
            $formInput.attr('required', parentValue);

            if (!parentValue) {
                $formInput.removeClass('input-validation-error');

                let $errorContainer = $formInput.siblings('span.error');
                $errorContainer.removeClass('field-validation-error').addClass('field-validation-valid');
            }
        });
    }

    toggleDependingForm(e) {
        let value = $(e.currentTarget).val();
        let name = $(e.currentTarget).attr('name').replace( 'Form.', '' );

        let questions = $(`[data-dependingquestion="${name}"]`);

        $(questions).each((index, item) => {
            if (Array.isArray(value)) {
                if (value.includes($(item).data('dependinganswer'))) {
                    $(item).show();
                    this.conditionallyRequiredToggle(true, $(item));
                }
                else {
                    $(item).hide();
                    this.conditionallyRequiredToggle(false, $(item));
                }
            }
            else {
                if (value.toLowerCase().indexOf($(item).data('dependinganswer').toLowerCase()) !== -1) {
                    $(item).show();
                    this.conditionallyRequiredToggle(true, $(item));
                }
                else {
                    $(item).hide();
                    this.conditionallyRequiredToggle(false, $(item));
                }
            }

            //handle depending answer being multiple options
            let dependingAnswer = $(item).data('dependinganswer');
            if (dependingAnswer.includes(',')) {
                const answers = dependingAnswer.split(',');
                if ($.inArray(value, answers) !== -1) {
                    $(item).show();
                    this.conditionallyRequiredToggle(true, $(item));
                }
                else {
                    $(item).hide();
                    this.conditionallyRequiredToggle(false, $(item));
                }
            }
        });
    }

    validateForm(e) {
        if ($('#recaptcha_contact')[0] && grecaptcha.getResponse().length === 0) {
            e.preventDefault();
            $('#recaptcha_contact').next().show();
            return false;
        }
        else {
            if ($('#recaptcha_contact')[0]) {
                $('#recaptcha_contact').next().hide();
            }
            return true;
        }
    }
}

export default Common;